import { render, staticRenderFns } from "./DeviceBox.vue?vue&type=template&id=68fd956a&scoped=true&"
import script from "./DeviceBox.vue?vue&type=script&lang=ts&"
export * from "./DeviceBox.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceBox.vue?vue&type=style&index=0&id=68fd956a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd956a",
  null
  
)

export default component.exports